// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "div[data-v-09ab1622]{color:#000}.fullscreen-center[data-v-09ab1622]{font-size:15px;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.reset[data-v-09ab1622]{width:100%;max-width:400px}.reset svg[data-v-09ab1622]{max-width:100%;fill:#02c2e8}.error[data-v-09ab1622]{padding-top:15px;color:#c55}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
